var map = {
	"./about/en.json": 845,
	"./about/fr.json": 846,
	"./about/he.json": 847,
	"./about/ru.json": 848,
	"./citiesDescription/en.json": 849,
	"./citiesDescription/fr.json": 850,
	"./citiesDescription/he.json": 851,
	"./citiesDescription/ru.json": 852,
	"./description/en.json": 853,
	"./description/fr.json": 854,
	"./description/he.json": 855,
	"./description/realEstate.json": 473,
	"./description/ru.json": 856,
	"./en.json": 1906,
	"./fr.json": 1907,
	"./he.json": 1908,
	"./privacy/en.json": 857,
	"./privacy/fr.json": 858,
	"./privacy/he.json": 859,
	"./privacy/ru.json": 860,
	"./projectsDescription/en.json": 861,
	"./projectsDescription/fr.json": 862,
	"./projectsDescription/he.json": 863,
	"./projectsDescription/ru.json": 864,
	"./ru.json": 1909,
	"./terms/en.json": 865,
	"./terms/fr.json": 866,
	"./terms/he.json": 867,
	"./terms/ru.json": 868
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3271;



//////////////////
// WEBPACK FOOTER
// ./src/translations ^\.\/.*\.json$
// module id = 3271
// module chunks = 0